/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarMonth = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2zm2 2v16h16V4zm2 5V7h2v2zm5 0V7h2v2zm5 0V7h2v2zM6 13v-2h2v2zm5 0v-2h2v2zm5 0v-2h2v2zM6 17v-2h2v2zm5 0v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCalendarMonth as CalendarMonth };
